import DeviceConfig from '@devices/config';
import FlavourConfig from '../config/flavours';

const SourcepointObj = window?._sp_;
const SourcepointGDPR = SourcepointObj?.gdpr;

const CmpUtils = {
  getGDPR: () => {
    if(DeviceConfig.capabilities.blockCmp) return ''
    let gdprConsent = '';
    if (!FlavourConfig.capabilities.cmp) {
      return gdprConsent;
    }
    try {
      __tcfapi('addEventListener', 2, (tcData, success) => {
        if (success) {
          gdprConsent = tcData.tcString;
        }
      });
    } catch (error) {
      console.error('[CMP utils]', error);
    }
    return gdprConsent;
  },
  isOpen: () => {
    if (!FlavourConfig.capabilities.cmp || DeviceConfig.capabilities.blockCmp) {
      return false;
    }
    try {
      if (SourcepointObj) {
        const element = document.querySelector('[id^=sp_message_container]');
        return !!element;
      } else if (SibboCMP) {
        return SibboCMP.isOpen();
      }
    } catch (error) {
      console.error('[CMP utils]', error);
      return false;
    }
    return false;
  },
  openBanner: (cb?: () => void) => {
    if (!FlavourConfig.capabilities.cmp || DeviceConfig.capabilities.blockCmp) {
      return;
    }
    try {
      // Load sourcepoint cmp
      if (SourcepointGDPR) {
        CmpUtils.openCmp(cb);
      }
      // Load sibbo cmp
      else if (SibboCMP) {
        SibboCMP.openBanner();
      }
    } catch (error) {
      cb && cb();
      console.error('[CMP utils]', error);
    }
  },
  openCmp: (cb?: () => void) => {
    if (!FlavourConfig.capabilities.cmp || DeviceConfig.capabilities.blockCmp) {
      return;
    }
    try {
      // Load sourcepoint cmp
      if (SourcepointGDPR) {
        if (DeviceConfig.info.os === 'Browser') {
          SourcepointGDPR.loadPrivacyManagerModal(
            DeviceConfig?.sourcepoint?.GDPR_PM_ID,
            'purposes'
          );
        } else {
          // Demo
          // SourcepointGDPR.loadNativeOtt(867049);
          // https://docs.sourcepoint.com/hc/en-us/articles/20806618675603-Resurface-OTT-message
          SourcepointGDPR.loadNativeOtt(DeviceConfig?.sourcepoint?.GDPR_OTT_ID);
        }
        // Listen to message ready and run callback
        window?._sp_queue.push(() => {
          SourcepointObj.addEventListener('onMessageReady', cb);
        });
      }
      // Load sibbo cmp
      else if (SibboCMP) {
        SibboCMP.open();
      }
    } catch (error) {
      cb && cb();
      console.error('[CMP utils]', error);
    }
  },
};

export default CmpUtils;
